export default __webpack_public_path__ + "static/media/ic_check_green.39254118.svg";